import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import { useNavigate, useParams } from 'react-router-dom';
import Message from '../components/LoadingError/Error';
import Loading from '../components/LoadingError/Loading';
import { cartProduct, findProduct } from '../service/ProductsService';
import { adminColors } from '../constants/constantsValues';

const SingleProduct = ({ user }) => {
  const [product, setProduct] = useState();
  const [qty, setQty] = useState(1);
  const [size, setSize] = useState();
  const [color, setColor] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const params = useParams();

  const productId = params.id;

  const navigate = useNavigate();

  useEffect(() => {
    findProduct(productId)
      .then((product) => {
        setProduct(product);
        setColor(adminColors.filter((el) => el.name === product.colors[0]));
        setSize(product.sizes[0]);
      })
      .catch((error) => setError(error.response.data.message));
  }, [productId]);

  useEffect(() => {
    if (product) {
      setLoading(false);
    }
  }, [product]);

  const AddToCartHandle = () => {
    cartProduct({
      product: product,
      color: color[0].name,
      size: size,
      qty: qty,
    }).then(() => navigate('/cart'));
  };

  const handleColor = (color) => {
    setColor(adminColors.filter((el) => el.name === color));
  };

  const handleRedirect = () => {
    navigate('/register');
  };

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      <div className='container single-product'>
        {error && <Message variant='alert-danger'>{error}</Message>}
        {loading ? (
          <Loading />
        ) : (
          <>
            <div className='row'>
              <div className='col-md-6'>
                <div className='single-image'>
                  <img src={product.image} alt={product.name} />
                </div>
              </div>
              <div className='col-md-6'>
                <div className='product-dtl'>
                  <div className='product-info'>
                    <div className='product-name'>{product.name}</div>
                  </div>
                  <p>{product.description}</p>

                  <div className='product-count'>
                    <div className='flex-box d-flex justify-content-between align-items-center'>
                      <h6>Precio</h6>
                      <span>
                        {product?.price.toString().replace('.', ',')}
                        {product?.price
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? product?.price
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </span>
                    </div>
                    <div className='flex-box d-flex justify-content-between align-items-center'>
                      <h6>Estado</h6>
                      {product.stock ? (
                        <span>En Stock</span>
                      ) : (
                        <span>No disponible</span>
                      )}
                    </div>
                    {/* <div className='flex-box d-flex justify-content-between align-items-center'>
                      <h6>Reviews</h6>
                      <Rating
                        value={product.rating}
                        text={`${product.numReviews} reviews`}
                      />
                    </div> */}
                    <div className='flex-box d-flex justify-content-between align-items-center'>
                      <h6>Talla</h6>
                      {product && product.sizes.length > 0 ? (
                        <select
                          value={size}
                          onChange={(e) => setSize(e.target.value)}
                        >
                          {product.sizes.map((size) => (
                            <option key={size} value={size}>
                              {size}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <span>No disponible</span>
                      )}
                    </div>
                    <div className='flex-box d-flex justify-content-between align-items-center'>
                      <h6>Color</h6>
                      <div className='d-flex align-items-center'>
                        {product.colors?.length > 0 ? (
                          product.colors.map((optionColor) => (
                            <div
                              className='mx-1 d-flex align-items-center'
                              style={{
                                width: `${
                                  color.name === optionColor ? '35px' : '30px'
                                }`,
                                height: `${
                                  color.name === optionColor ? '35px' : '30px'
                                }`,
                                backgroundColor: `${
                                  adminColors.filter(
                                    (el) => el.name === optionColor
                                  )[0]?.color
                                }`,
                                border: '1px solid black',
                                borderRadius: '50%',
                                cursor: 'pointer',
                              }}
                              onClick={() => handleColor(optionColor)}
                              key={optionColor}
                            ></div>
                          ))
                        ) : (
                          <span>No disponible</span>
                        )}
                      </div>
                    </div>
                    {product.stock && user ? (
                      <>
                        <div className='flex-box d-flex justify-content-between align-items-center'>
                          <h6>Cantidad</h6>
                          <select
                            value={qty}
                            onChange={(e) => setQty(e.target.value)}
                          >
                            {[...Array(20).keys()].map((x) => (
                              <option key={x + 1} value={x + 1}>
                                {x + 1}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          onClick={AddToCartHandle}
                          className='round-black-btn'
                        >
                          Añadir al carrito
                        </button>
                      </>
                    ) : product.stock && !user ? (
                      <>
                        <div className='flex-box d-flex justify-content-between align-items-center'></div>
                        <button
                          onClick={handleRedirect}
                          className='round-black-btn'
                        >
                          Haz click para crear una cuenta
                        </button>
                      </>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SingleProduct;
